// apps/web/src/components/landing-v2/proofs/KeepThreadProof.tsx
/** Theme 01 / Keep the thread — Cosmic-only. A saved question + card
 *  pull + an interpretation + follow-up chips.  Reference: .mm-thread. */
export function KeepThreadProof() {
  return (
    <div className="absolute inset-0 flex flex-col gap-2 p-[18px]">
      <p className="text-[10px] uppercase tracking-[0.22em] text-text-muted">
        Your reading · keeps going
      </p>
      <div
        className="border-l-2 pl-2.5 font-display italic text-text-primary"
        style={{ borderColor: 'color-mix(in oklab, var(--color-gold-light-legacy) 40%, transparent)', fontSize: '0.8rem' }}
      >
        What should I trust right now?
      </div>
      <div
        className="flex items-center gap-2 rounded-lg border p-2"
        style={{
          background: 'color-mix(in oklab, var(--color-astral-violet) 5%, transparent)',
          borderColor: 'color-mix(in oklab, var(--color-astral-violet) 20%, transparent)',
        }}
      >
        <div
          className="aspect-[5/7] w-[30px] overflow-hidden rounded border border-hairline"
          style={{ background: 'var(--color-deep-purple)' }}
        >
          <img
            src="/cards/the-star.webp"
            alt=""
            loading="lazy"
            className="h-full w-full object-cover"
          />
        </div>
        <span className="inline-flex items-center rounded-pill border border-gold-light-legacy/30 bg-gold-light-legacy/[0.14] px-2 py-0.5 text-[9px] uppercase tracking-[0.14em] text-gold-light-legacy">
          The Star · Upright
        </span>
      </div>
      <div
        className="rounded-r-lg border-l-2 px-2.5 py-2 font-display text-text-primary"
        style={{
          borderColor: 'color-mix(in oklab, var(--color-astral-violet) 45%, transparent)',
          background: 'color-mix(in oklab, var(--color-astral-violet) 5%, transparent)',
          fontSize: '0.78rem',
          lineHeight: 1.45,
        }}
      >
        Trust the slow rebuild. The Star is patient — light returning, not arriving.
      </div>
      <div className="mt-auto flex gap-1.5 pt-1">
        <span
          className="rounded-pill border px-2 py-1 text-[10px] text-astral-violet-light"
          style={{
            background: 'color-mix(in oklab, var(--color-astral-violet) 10%, transparent)',
            borderColor: 'color-mix(in oklab, var(--color-astral-violet) 25%, transparent)',
          }}
        >
          Why this card?
        </span>
        <span
          className="rounded-pill border px-2 py-1 text-[10px] text-astral-violet-light"
          style={{
            background: 'color-mix(in oklab, var(--color-astral-violet) 10%, transparent)',
            borderColor: 'color-mix(in oklab, var(--color-astral-violet) 25%, transparent)',
          }}
        >
          Next step?
        </span>
      </div>
    </div>
  )
}
